import cx from 'classnames';
import { forwardRef, ReactElement, SVGAttributes } from 'react';

import style from './IconButton.module.css';

export type Props = React.ComponentPropsWithoutRef<'button'> & {
    Icon: (props: SVGAttributes<SVGElement>) => ReactElement;
    isHovered?: boolean;
    color?: string;
};

export const HomeIconButton = forwardRef<HTMLButtonElement, Props>(
    ({ className, Icon, isHovered = false, ...props }, ref) => {
        return (
            <button
                {...props}
                ref={ref}
                className={cx(style.button, className, { [style.isHovered]: isHovered })}
                type="button"
            >
                <Icon className={style.icon} color={props.color} />
            </button>
        );
    },
);
